import { confirmAlert } from "react-confirm-alert"; // Import

export const useconfirmAlert = ({ onConfirm, title }) => {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <div className="custom-ui">
          <h6 style={{ marginBottom: 20 }}>{title ? title : "Are you sure, do you want to delete this document?"}</h6>
          <div
            className="row"
            style={{
              marginTop: 20,
            }}
          >
            <div className="col-6">
              <button onClick={onClose} type="submit" className="btn btn-warning w-100">
                Cancel
              </button>
            </div>
            <div className="col-6">
              <button
                onClick={() => {
                  onConfirm();
                  onClose();
                }}
                type="submit"
                className="btn btn-primary w-100"
                data-cy="deletefileconfirm"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      );
    },
  });
};
